import { NgModule } from '@angular/core';
import { AuthModule } from '@features/auth/auth.module';
import { ApplicationInsightsService } from './application-insights.service';

@NgModule({
  imports: [AuthModule],
  declarations: [],
  providers: [ApplicationInsightsService],
  exports: [],
})
export class ApplicationInsightsModule {}
